import { render, staticRenderFns } from "./CoverageDocumentationModal.vue?vue&type=template&id=167ebffe&scoped=true&"
import script from "./CoverageDocumentationModal.vue?vue&type=script&lang=js&"
export * from "./CoverageDocumentationModal.vue?vue&type=script&lang=js&"
import style0 from "./CoverageDocumentationModal.vue?vue&type=style&index=0&id=167ebffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ebffe",
  null
  
)

export default component.exports